<template>
	<h1 class="type-title" :is="label" :style="_style" @click="$emit('click', $event)">
		<!-- h1 font-size: 32px; -->
		<!-- h2 font-size: 24px; -->
		<!-- h3 font-size: 19px; -->
		<!-- h4 font-size: 16px; -->
		<!-- h5 font-size: 13.5px; -->
		<!-- h6 font-size: 12px; -->
		<slot></slot>
	</h1>
</template>

<script>
	export default {
		name: 'type-title',
		props: {
			large: {
				type: Boolean,
				default: false		// 默认
			},
			medium: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			left: {
				type: Boolean,
				default: false
			},
			center: {
				type: Boolean,
				default: false
			},
			right: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: ''
			},
			weight: {
				type: String,
				default: '300'
			},
			padding: {
				type: String,
				default: '0 0 25px'
			},
			grade: {
				type: String,
				default: '',	// 1 ~ 6
				validator: (value => value === '') || (Number(value) && Number(value) < 7)
			}
		},
		computed: {
			_style() {
				let style = '';
				const styleObj = {
					'left': 'text-align: left;',
					'center': 'text-align: center;',
					'right': 'text-align: right;',
					'size': `font-size: ${this.size};`,
					'padding': `padding: ${this.padding};`,
					'weight': `font-weight: ${this.weight};`
				};
				Object.keys(styleObj).forEach(key => {
					if (this[key]) {
						style += styleObj[key];
					}
				});
				if (style.includes('text-align') === false) {
					style += styleObj['center'];
				}
				return style;
			},
			label() {
				if (this.grade) {
					return `h${this.grade}`;
				}
				const labelObj = {
					'large': 'h1',
					'medium': 'h2',
					'small': 'h3'
				};
				let label = Object.keys(labelObj).find(key => this[key]) || '';
				if (label === '') {
					return labelObj['large'];
				}
				return labelObj[label];
			}
		}
	}
</script>

<style scoped lang="less">
	.type-title{
		width: 100%;
		font-weight: 300;
		font-family: 'Montserrat', sans-serif;
		// background-color: red;
	}
</style>
